import * as byRefFuncLibrary from './byRefFunctionLibrary'
import { BeckyFunctionLibrary, BeckyModel, BeckyRequestPayload } from '../types/becky'
import { flattenStructure } from '../flattenStructure'
import { Data, Structure } from '@wix/thunderbolt-becky-types'
import { RefBeckyModel } from '../types/byRef'
import _ from 'lodash'

const byRefModelFactory = require('./carmi/byRefs.carmi')

const runCarmiAsync = (model: RefBeckyModel, funcLib: BeckyFunctionLibrary) =>
	new Promise((done) => byRefModelFactory(model, { ...funcLib, done }))

const hasUnresolvedByRefComp = (structure: Structure) => {
	return _(structure)
		.values()
		.filter((comp) => !!comp.componentType && comp.componentType.endsWith('RefComponent'))
		.map('components')
		.some(_.isEmpty)
}

const resolveRecursivelyIfNeeded = async (
	model: RefBeckyModel,
	funcLib: BeckyFunctionLibrary
): Promise<{ structure: Structure; data: Data }> => {
	if (!hasUnresolvedByRefComp(model.structure)) {
		return model
	}
	const { structure, data } = (await runCarmiAsync({ ...model }, funcLib)) as {
		structure: Structure
		data: Data
	}

	return resolveRecursivelyIfNeeded({ ...model, structure, data }, funcLib)
}

export const resolveByRefComponents = (
	beckyModel: BeckyModel,
	masterPageStructure: Structure,
	masterPageData: Data,
	functionLibrary: BeckyFunctionLibrary,
	requestPayload: BeckyRequestPayload
): Promise<{ structure: Structure; data: Data }> =>
	functionLibrary.runAsyncAndReport(async () => {
		const funcLib = { ...functionLibrary, ...byRefFuncLibrary, flattenStructure }
		const resolveGhosts = requestPayload.resolveGhosts === 'true'

		const masterPageResolved: any = await resolveRecursivelyIfNeeded(
			{
				...beckyModel,
				structure: masterPageStructure,
				data: masterPageData,
				masterPageStructure,
				masterPageData,
				requestPayload,
				resolveGhosts,
			},
			funcLib
		)

		return beckyModel.pageCompId === 'masterPage'
			? masterPageResolved
			: resolveRecursivelyIfNeeded(
					{
						...beckyModel,
						masterPageStructure: masterPageResolved.structure,
						masterPageData: masterPageResolved.data,
						requestPayload,
						resolveGhosts,
					},
					funcLib
			  )
	}, 'tb-byRef-resolving')
